/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
// eslint-disable-next-line
import { extend } from 'umi-request';
import utils from './index';
// import { history } from 'umi';

/**
 * 异常处理程序
 */

const errorHandler = error => {
  const { response } = error;
  console.log('error',error) //if (typeof value === "object" && value !== null) {

  if (response && response.status) {
    const { status, url } = response;
    utils.msg.error(`请求错误 ${status}: ${url}`)
  } else if (!response) {
    // console.log('error',error)
    let errString = error.toString();
    if(errString.indexOf('timeout')>=0){ //!=-1 方法可返回某个指定的字符串值在字符串中首次出现的位置。
      // 超时
      // console.log('errString',error)
      utils.msg.error('请求超时')
    }else{
      utils.msg.error(error.toString())
    }
  }

  return Promise.reject(response);
};
/**
 * 配置request请求时的默认参数
 */

let request = extend({
    prefix:'sso',
    errorHandler, // 默认错误处理
    timeout: 5000,
    credentials: 'include', // 默认请求是否带上cookie
});

// request拦截器, 改变url 或 options.
request.interceptors.request.use(async (url, options) => {

  let userToken = utils.getStorage('userToken')||null;
  const headers = {
    ...options.headers,
    userToken
  };
  return (
    {
      url: url,
      options: { ...options, headers: headers },
    }
  );

})

// response拦截器, 处理response
request.interceptors.response.use(async (response, options) => {
  const data = await response.clone().json();
  if (response.status === 200) {
    console.log('response',data.code === 2100)
    if (data.code === 200) {
      // 成功

    } else if (data.code === 2100) {
      // 会话过期
      utils.msg.error("会话过期，请重新登录!");
      window.location='/login'
      return;
    } else{
      // 出现错误
      if(data.message){
        utils.msg.error( data.message); 
      }
      // 文件导出 无message
    }
    return Promise.resolve(response);
  } else if(response.status === 404){
    window.location = '/error';
    return
  } else {
    return Promise.reject(response);
  }
  // return response;
});


export default request;
